<template>
  <b-container fluid="true" style="margin:20px; max-width: 1000px;">
    <b-row>
      <b-col cols="2"></b-col>
      <b-col cols="8">
        *Comment
      </b-col>
    </b-row>
    <b-row style="margin-bottom: 30px">
      <b-col cols="2"></b-col>
      <b-col cols="8">
        <b-form-textarea v-model="comment" debounce="1000"></b-form-textarea>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: "MetricComment",
  props: {
    groupId: String,
    year: String,
    metricType: String
  },
  data() {
    return {
      id: null,
      myGroupId: this.groupId,
      comment: '',
      myYear: this.year,
      createdAt: null,
      updatedAt: null,
      myMetricType: this.metricType
    }
  },
  mounted() {
    this.getPageComment();
  },
  watch: {
    response: function (val) {
      this.selectedResponse = val;
    },
    comment: function (newComment) {
      this.updateComment(newComment);
    }
  },
  methods: {
    getPageComment: function () {
      this.$http.get(`metrics/comment/${this.myGroupId}/${this.myYear}/${this.myMetricType}`)
          .then(result => {
            let commentObject = result.data;
            if (commentObject !== null) {
              this.id = commentObject._id;
              this.myGroupId = commentObject.groupId;
              this.comment = commentObject.comment;
              this.myYear = commentObject.year;
              this.createdAt = commentObject.createdAt;
              this.updatedAt = commentObject.updatedAt;
              this.myMetricType = this.metricType;
            }
          })
          .catch(error => {
            console.log(`Couldn't Retrieve Comments for groupId ${this.myGroupId}, year: ${this.myYear}, metric type: ${this.myMetricType}  with error`, error.message);
          })
    },
    updateComment: function (commentValue) {
      let commentText = commentValue;
      let theMethod = this.id === null ? 'post' : 'put';
      let url = this.id === null ? `metrics/comment` : `metrics/comment/${this.id}`;
      this.createdAt = this.createdAt !== null ? this.createdAt : Date.now();
      this.updatedAt = this.updatedAt !== null ? this.updatedAt : Date.now();
      let self = this;
      this.$http.request(
          {
            method: theMethod,
            url: url,
            data: {
              _id: this.id,
              groupId: this.myGroupId,
              comment: commentText,
              year: this.year,
              createdAt: this.createdAt,
              updatedAt: this.updatedAt,
              metricType: this.myMetricType
            }
          })
          .then(result => {
            if (theMethod === 'post') {
              self.id = result.data._id;
              self.updatedAt = result.data.updatedAt;
            }
            console.log(`Updated; ${self.updatedAt}`)
          })
          .catch(error => {
            let action = theMethod === 'post' ? 'create' : 'update';
            console.log(`Couldn't ${action} Comments for groupId ${this.myGroupId}, year: ${this.myYear}, metric type: ${this.myMetricType}  with error`, error.message);
          })
    }
  }

}
</script>

<style scoped>
p {
  display: flex;
  width: 600px;
}

p:before {
  padding-right: 4px;
}

.question-number {
  position: absolute;
  top: 0;
  left: 0;
  margin-right: 5px;
  text-align: right;
}

.question-text {
  padding-left: 10px;
  padding-bottom: 10px;
  margin-left: 10px;
  width: 100%;
  font-size: 20px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  display: inline-block;
}

.question-text >>> a {
  color: #28763a;
}

.green-note-label {
  color: #1c7430;
  margin-left: 15px;
  margin-top: 0;
  padding-top: 0;
  font-size: 16px;
  font-style: italic;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

.green-note {
  color: #1c7430;
  margin-left: -5px;
  margin-top: 0;
  font-size: 16px;
  font-style: italic;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

a {
  color: darkgreen;
  font-family: "Times New Roman"
}

a:visited {
  color: orange;
}

a:link {
  color: #28763a;
}

qtext >>> a {
  color: #28763a;
}

greenNote >>> a {
  color: #28763a;
}


/*.custom-control-label ::before {
   /background: white;
   border: 2px solid #b7b9bc;
   border-radius: 100%;
   cursor: pointer;
   top: calc((100% - 16px)/2);
 }*/
/*.custom-control-label ::after {
   top: calc((100% - 16px)/2);
 }*/

</style>
